export default __webpack_public_path__ + "static/Kira Kutcher - Age 11 Figure Skating Performance-ac9be2fbe85219efdfe722b6d685a56c.png";